module.exports = __webpack_public_path__ + "rookieusa-app-icon.d6dcd997dc6d042a37fa3965930e6a92.png";